import { connect } from "react-redux";

import Redirection from "../../components/Redirection/Redirection";

import { logout } from "../../actions/user";

const mapStateToProps = () => ({});
const mapDispatchToProps = (dispatch) => ({
	logout: () => {dispatch(logout());}
});

export default connect(mapStateToProps, mapDispatchToProps)(Redirection);